/**
 * @desc 分页角色列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.RoleOfPagingQueryConditions>): Promise<BaseResponse<defs.PageBean<Array<defs.SysRoleEntityObject>>>> {
  return fetch({
    url: config.API_HOST + '/auth/role/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
